import React, { Component } from 'react';
import { Router, Route, Redirect, Switch } from 'react-router';
import { createBrowserHistory } from 'history';

import logo from './logo.png';
import './App.css';

class Home extends Component {
  render() {
    return (
      <p className="App-intro">
        There is nothing to be seen here for now.
      </p>
    );
  }
}

class Error404 extends Component {
  render() {
    return (
      <div className="App-intro">
        <h1>404</h1>
        <p>
          The page you requested can not be found.
        </p>
      </div>
    );
  }
}

class MaintenanceCloud extends Component {
  render() {
    return (
      <div>
        <p className="App-intro">
          KTO Cloud is currently in maintenance mode. Should you need more info, ask Alexandre.
        </p>
        <p className="App-intro">
          KTO Cloud est actuellement en maintenance. Si tu veux plus d'informations, demande à Alexandre.
        </p>
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {history: createBrowserHistory()};
  }

  render() {
    return (
      <Router history={this.state.history}>
        <div className="App">
          <div className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <h2>Welcome to KTO domain</h2>
          </div>

          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/404" component={Error404} />
            <Route exact path="/cloud" component={MaintenanceCloud} />
            <Redirect from="/*" to="/404" />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js